// Catalog of assignable modules for candidate team members.
// Keep the `key` values in sync with backend middleware/auth.js MODULE_KEYS.
// `urls` are the route prefixes each module unlocks (used to filter the sidebar).

export const MODULES = [
  { key: 'command-center',    label: 'Command Center',     urls: ['/command-center'] },
  { key: 'activities',        label: 'Mhesh Activities',   urls: ['/activities'] },
  { key: 'voter-intelligence',label: 'Voter Intelligence', urls: ['/voter-intelligence'] },
  { key: 'voters',            label: 'My Voters',          urls: ['/voter-register'] },
  { key: 'manifesto',         label: 'Manifesto',          urls: ['/manifesto'] },
  { key: 'ai-assistant',      label: 'AI Assistant',       urls: ['/mhesh-ai-assistant'] },
  { key: 'news',              label: 'News Intelligence',  urls: ['/news-intelligence'] },
  { key: 'polls',             label: 'Polls & Surveys',    urls: ['/polls-surveys', '/elections/poll-results'] },
  { key: 'reports',           label: 'Reports',            urls: ['/reports'] },
  { key: 'communications',    label: 'Communications',     urls: ['/communications'] },
  { key: 'ground-operations', label: 'Ground Operations',  urls: ['/ground-operations', '/agent-activity'] },
  { key: 'elections',         label: 'Elections / Tally',  urls: ['/elections/tally-results', '/elections/reported-incidents'] },
  { key: 'finance',           label: 'Finance',            urls: ['/finance'] },
  { key: 'campaign-team',     label: 'Campaign Team',      urls: ['/campaign-team'] }
];

export const MODULE_LABEL = MODULES.reduce((a, m) => { a[m.key] = m.label; return a; }, {});

/** Which module a URL belongs to (longest-prefix match), or null if not module-gated. */
export function moduleForUrl(url) {
  if (!url) return null;
  let best = null, bestLen = -1;
  for (const m of MODULES) {
    for (const p of m.urls) {
      if ((url === p || url.startsWith(p)) && p.length > bestLen) { best = m.key; bestLen = p.length; }
    }
  }
  return best;
}

/** Is a URL visible given the user's allowed modules? allowed === null ⇒ owner (all). */
export function urlAllowed(url, allowed) {
  if (!allowed) return true;            // owner / unrestricted
  const key = moduleForUrl(url);
  if (!key) return true;                // not module-gated (settings, team, etc.)
  return allowed.includes(key);
}
